<div class="flex-footer">
    <div class="flex-footer-left">
        <div class="footerBlock" *ngIf="LoginSettings.OneSISVersion != '' && LoginSettings.LegacyVersion == ''">
            <div class="sis-app-bold-label">
                Version
            </div>
            <div class="sis-app-bold-label">
                {{LoginSettings.OneSISVersion}}
            </div>
        </div>
        <div class="footerBlock" *ngIf="LoginSettings.LegacyVersion != undefined && LoginSettings.LegacyVersion != ''">
            <div class="sis-app-bold-label">
                360 Version {{LoginSettings.OneSISVersion}}
            </div>
            <div class="sis-app-regular-label">
                C {{LoginSettings.LegacyVersion}}
            </div>
            <div class="sis-app-regular-label" *ngIf="LoginSettings.ReportsVersion != ''">
                R {{LoginSettings.ReportsVersion}}
            </div>
        </div>
    </div>
    <div class="flex-footer-middle">
        <div class="footerBlock">
            <div class="sis-app-bold-label">
                &copy; {{copyrightYear}} Copyright Tyler Technologies, Inc.
            </div>
            <div class="sis-app-bold-label" style="text-align: center;">
                All rights reserved.
            </div>
        </div>
    </div>
    <div class="flex-footer-right">
        <div *ngIf="!LoginSettings.ForceNewApplication">
            <div *ngIf="LoginSettings.TryNewApplication && !LoginSettings.ForceNewApplicationPS"
                style="padding-top: 15px; padding-right: 10px;">
                <span style="padding:5px;background-color:#ffff99">
                    <a (click)="currentApplicationClick()"
                        style="text-decoration:none; color:blue; cursor:pointer;text-decoration:underline;">
                        Go back to the current release: SIS K-12 360 v2</a>
                </span>
            </div>
            <div style="padding-top: 15px; padding-right: 10px;"
                *ngIf="LoginSettings.ForceNewApplicationPS && userType==1">
                <span style="padding:5px;background-color:#ffff99">
                    <a (click)="currentApplicationClick()"
                        style="text-decoration:none; color:blue; cursor:pointer;text-decoration:underline;">
                        Use the older version of SIS K-12</a>
                </span>
            </div>
        </div>

        <div class="footerBlock" *ngIf="false">
            <div>
                <img src="./assets/images/mobile.png" style="cursor: pointer;" />
            </div>
            <div>
                Mobile
            </div>
        </div>
    </div>
</div>